import React from 'react';
import { object } from 'prop-types';
import styled from 'styled-components';

import Message from './Message';


const Container = styled.div`
    position: absolute;
    top: 63px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
    z-index: ${p => p.theme.zIndex.flashIt};
`;

const FlashIt = ({ messages, ...props }) => (
    <Container>
        { Object.entries(messages).map(([id, data]) => (
            <Message
                key={id}
                id={id}
                {...data}
                {...props}
            />
        )) }
    </Container>
);

FlashIt.propTypes = {
    messages: object.isRequired,
};

export default FlashIt;
